import React, { useEffect, useState } from "react";
import {
  getAllCoupons,
  createCoupon,
  updateCoupon,
  deleteCoupon,
} from "../../services/adminApi";

import "./CouponRedeem.css";

const CouponRedeem = () => {
  const [coupons, setCoupons] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    coupon_code: "",
    coupon_type: "fix",
    amount: "",
    no_of_coupons_available: "",
    can_use_multiple_time: false,
  });

  useEffect(() => {
    loadCoupons();
  }, []);

  // =========================
  // LOAD COUPONS
  // =========================

  const loadCoupons = async () => {
    try {
      const res = await getAllCoupons();

      if (res.data.success) {
        setCoupons(res.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // =========================
  // RESET FORM
  // =========================

  const resetForm = () => {
    setEditId(null);

    setShowForm(false);

    setFormData({
      coupon_code: "",
      coupon_type: "fix",
      amount: "",
      no_of_coupons_available: "",
      can_use_multiple_time: false,
    });
  };

  // =========================
  // SAVE / UPDATE
  // =========================

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editId) {
        await updateCoupon(editId, formData);

        alert("Coupon Updated Successfully");
      } else {
        await createCoupon(formData);

        alert("Coupon Created Successfully");
      }

      resetForm();

      loadCoupons();
    } catch (err) {
      alert(err?.response?.data?.message || "Error");
    }
  };

  // =========================
  // EDIT
  // =========================

  const handleEdit = (coupon) => {
    setEditId(coupon.id);

    setFormData({
      coupon_code: coupon.coupon_code,
      coupon_type: coupon.coupon_type,
      amount: coupon.amount,
      no_of_coupons_available:
        coupon.no_of_coupons_available,
      can_use_multiple_time:
        coupon.can_use_multiple_time,
    });

    setShowForm(true);
  };

  // =========================
  // DELETE
  // =========================

  const handleDelete = async (id) => {
    if (!window.confirm("Delete Coupon?")) return;

    try {
      await deleteCoupon(id);

      alert("Coupon Deleted");

      loadCoupons();
    } catch (err) {
      alert("Delete Failed");
    }
  };

  return (
    <div className="coupon-page">

      {/* ========================= */}
      {/* ADD / EDIT FORM */}
      {/* ========================= */}

      {showForm && (
        <div className="coupon-card">

          <div className="coupon-header">
            <h2>
              {editId
                ? "Edit Coupon"
                : "Add Coupon"}
            </h2>

            <button
              className="btn btn-secondary"
              onClick={resetForm}
            >
              Cancel
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row">

              {/* CODE */}
              <div className="col-md-12 mb-4">
                <label className="mb-2">
                  Coupon Code
                </label>

                <input
                  type="text"
                  className="form-control coupon-input"
                  value={formData.coupon_code}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      coupon_code: e.target.value,
                    })
                  }
                  required
                />
              </div>

              {/* TYPE */}
              <div className="col-md-6 mb-4">
                <label className="mb-2">
                  Coupon Type
                </label>

                <select
                  className="form-select coupon-input"
                  value={formData.coupon_type}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      coupon_type: e.target.value,
                    })
                  }
                >
                  <option value="fix">
                    Fixed
                  </option>

                  <option value="per">
                    Percentage
                  </option>
                </select>
              </div>

              {/* AMOUNT */}
              <div className="col-md-6 mb-4">
                <label className="mb-2">
                  Amount
                </label>

                <input
                  type="number"
                  className="form-control coupon-input"
                  value={formData.amount}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      amount: e.target.value,
                    })
                  }
                  required
                />
              </div>

              {/* AVAILABLE */}
              <div className="col-md-6 mb-4">
                <label className="mb-2">
                  Available Coupons
                </label>

                <input
                  type="number"
                  className="form-control coupon-input"
                  value={
                    formData.no_of_coupons_available
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      no_of_coupons_available:
                        e.target.value,
                    })
                  }
                  required
                />
              </div>

              {/* MULTI USE */}
              <div className="col-md-6 d-flex align-items-center mt-4">
                <input
                  type="checkbox"
                  checked={
                    formData.can_use_multiple_time
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      can_use_multiple_time:
                        e.target.checked,
                    })
                  }
                  className="coupon-checkbox"
                />

                <label>
                  Allow Multiple Use
                </label>
              </div>

              {/* BUTTON */}
              <div className="col-md-12 mt-3">
                <button
                  className="btn btn-primary"
                  type="submit"
                >
                  {editId
                    ? "Update Coupon"
                    : "Save Coupon"}
                </button>
              </div>

            </div>
          </form>
        </div>
      )}

      {/* ========================= */}
      {/* LIST SECTION */}
      {/* ========================= */}

      {!showForm && (
        <div className="coupon-card">

          {/* HEADER */}
          <div className="coupon-header">
            <h2>Coupon Management</h2>

            <button
              className="btn btn-danger add-btn"
              onClick={() => {
                resetForm();
                setShowForm(true);
              }}
            >
              + Add New Coupon
            </button>
          </div>

          {/* TABLE */}
          <div className="table-responsive">
            <table className="table table-dark align-middle coupon-table">
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>TYPE</th>
                  <th>AMOUNT</th>
                  <th>AVAILABLE</th>
                  <th>USAGE</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>

              <tbody>
                {coupons.length > 0 ? (
                  coupons.map((coupon) => (
                    <tr key={coupon.id}>

                      <td>
                        {coupon.coupon_code}
                      </td>

                      <td>
                        {coupon.coupon_type ===
                        "fix"
                          ? "Fixed"
                          : "Percentage"}
                      </td>
                      
                      <td>
                        {coupon.coupon_type === "fix" && (
                          <>₹ {coupon.amount}</>
                        )}

                        {coupon.coupon_type === "per" && (
                          <>{coupon.amount}%</>
                        )}
                      </td>

                      <td>
                        {
                          coupon.no_of_coupons_available
                        }
                      </td>

                      <td>
                        {coupon.can_use_multiple_time ? (
                          <span className="multi-use">
                            Multi Use
                          </span>
                        ) : (
                          <span className="one-time">
                            One Time
                          </span>
                        )}
                      </td>

                      <td>
                        <div className="d-flex gap-2">

                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() =>
                              handleEdit(coupon)
                            }
                          >
                            Edit
                          </button>

                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() =>
                              handleDelete(coupon.id)
                            }
                          >
                            Delete
                          </button>

                        </div>
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      className="text-center py-4"
                    >
                      No Coupons Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      )}
    </div>
  );
};

export default CouponRedeem;